import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCouchbaseComponent } from './simple-icons-couchbase.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCouchbaseComponent ],
    exports:      [ SimpleIconsCouchbaseComponent ],
    bootstrap:    []
})
export class SimpleIconsCouchbaseModule {}
